import {Link, NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import CloseIcon from "./common/CloseIcon";
import {useState} from "react";
import {products} from "../data/data";
import ic_up from "../assets/icon/ic_up.svg";
import ic_down from "../assets/icon/ic_down.svg";
import {languages} from "../data/data";
import i18n from "i18next";

function HamburgerMenu(props) {
    const {t} = useTranslation();
    const onClick = () => {
        props.toggleMenu();
        navigateToTop();
    }
    const navigateToTop = () => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }
    return (
        <>
            <div onClick={props.toggleMenu}>
                <CloseIcon/>
            </div>
            <div className="absolute top-24 left-0 bg-gray-light flex flex-col min-w-full">
                <ProductAccordion className="border-b text-base" onClick={onClick}/>
                <NavLink to="/about" onClick={onClick}
                         className="ham-menu px-8">
                    {t("navigation_menu_about")}
                </NavLink>
                <NavLink to="/contact" onClick={onClick}
                         className="ham-menu px-8">
                    {t("navigation_menu_contact")}
                </NavLink>
                <LanguageAccordion onClick={props.toggleMenu}/>
            </div>
        </>
    )
}

export default HamburgerMenu

function LanguageAccordion(props) {
    const onLanguageChanged = async (key) => {
        await i18n.changeLanguage(key);
        props.onClick();
    };

    return (
        <div className={props.className}>
            <AccordionItem title="Language" highlight="bg-yellow">
                {
                    languages.map((language, index) => (
                        <div key={index}
                             onClick={() => onLanguageChanged(language.key)}
                             className="flex flex-row items-center
                                        py-4 px-8 hover:bg-gray-light">
                            <img src={language.image} className="w-4 aspect-square mr-2"
                                 alt={`Flag image: ${language.key}`}/>
                            <span>{language.name}</span>
                        </div>
                    ))
                }
            </AccordionItem>
        </div>
    );
}

function ProductAccordion(props) {
    const {t} = useTranslation();
    return (
        <div className={props.className}>
            <AccordionItem title={t('navigation_menu_product')} highlight="bg-yellow">
                {
                    products.map(product => (
                        <AccordionItem title={product.category} key={product.id}>
                            <>
                                {
                                    product.groups.map(group => (
                                        <>
                                            <div className="font-bold text-sm mt-2 text-left py-2 px-8">
                                                {t(group.name)}
                                            </div>
                                            {
                                                group.items.map((item, index) => (
                                                    <Link key={index}
                                                          to={`/product/${product.type}/${item.id}`}
                                                          onClick={props.onClick}
                                                          className="flex flex-row items-center gap-4 py-2 my-1
                                                                    hover:bg-gray-light px-8">
                                                        <img src={item.icon}
                                                             className="w-9 aspect-square object-contain"
                                                             alt={item.title}/>
                                                        <div>{t(item.title)}</div>
                                                    </Link>
                                                ))
                                            }
                                        </>
                                    ))
                                }
                            </>
                        </AccordionItem>
                    ))
                }
            </AccordionItem>
        </div>
    );
}

function AccordionItem({title, children, highlight}) {
    const {t} = useTranslation();
    const [selected, setSelected] = useState("");

    const toggle = () => {
        setSelected(selected === "" ? "active" : "");
    };

    return (
        <>
            <div className={`flex flex-row justify-between px-8 py-4
                            ${selected === "active" ? highlight : ""}`}
                 onClick={() => toggle()}
                 style={{cursor: "pointer"}}
            >
                {t(title)}
                <img src={selected === "active" ? ic_up : ic_down} alt="Arrow"/>
            </div>
            {selected && (
                <div className="bg-white">{children}</div>
            )}
        </>
    );
}